export default function blockStyleCopyIsBtnActive() {
  const clipboard = this.state.clipboard;
  if (clipboard.key) {
    return true;
  }
  return false;
}
